import { combineReducers } from "redux";
import { SET_FETCHED_CLIENT, RESET_STATE, SET_LOADING   } from "./actions";

const fetchedClientReducer = (state = null, action) => {
  switch (action.type) {
    case SET_FETCHED_CLIENT:
      return action.payload;
    case RESET_STATE:
      return null;
    default:
      return state;
  }
};
const loadingReducer = (state = true, action) => {
  switch (action.type) {
    case SET_LOADING:
      return action.payload;
    default:
      return state;
  }
};
const rootReducer = combineReducers({
  loading: loadingReducer,
  fetchedClient: fetchedClientReducer,
});

export default rootReducer;
